module.exports = __webpack_public_path__ + "img/山楂标题.f6587b54.png";